/**
 * 出庫表單 → create API payload（camel；再交 API serialize／keysToSnake）。
 * 禁止 header sourceType／sourceId；禁止 lossQty。
 * stockIssueCategoryId 由 serialize 層固定帶入，表單不含此欄。
 */
export function mapOutboundFormToCreatePayload(values) {
  return {
    issueDate: values?.issueDate,
    issueReason: values?.issueReason || null,
    remark: values?.remark || null,
    lines: (values?.lines ?? []).map((line) => {
      const sourceType = line?.sourceType;
      const mapped = {
        sourceType,
        qty: line?.qty === '' || line?.qty == null ? null : Number(line.qty),
      };

      if (sourceType === 'PENDING_ALLOCATION') {
        mapped.pendingAllocationId = line?.pendingAllocationId;
        return mapped;
      }

      mapped.invStockId = line?.invStockId;
      return mapped;
    }),
  };
}
